import { Component, OnInit, AfterViewInit } from '@angular/core';

import { ClipboardService } from 'ngx-clipboard'
import { HttpClient } from '@angular/common/http';
import { Mode } from './utility/enums/enums';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalFormComponent } from './modal-form/modal-form.component';

@Component({
  providers: [HttpClient],
  selector: 'form-guide',
  templateUrl: './form-guide.component.html',
  styleUrls: ['./form-guide.component.scss']
})

export class FormGuideComponent implements OnInit, AfterViewInit {
  title = 'MTT Portal';

  // Pagination
  page = 1;
  // Messages
  success: Mode = Mode.Success;
  error: Mode = Mode.Error;
  warning: Mode = Mode.Warning;
  empty: Mode = Mode.Empty;
  // Copy
  mainTitleHtml = `
  <h2 class="main-title">Section Title</h2>
  `;

  tooltipHtml = `
  <span ngbTooltip="Tooltip Text Content" triggers="mouseenter:mouseleave click" [autoClose]="'outside'">Tooltip</span>
  `;

  imgWrapperHtml = `
  <div class="row justify-content-center">
    <div class="img-wrapper">
        <img src='../assets/images/default-news-image.jpg'>
    </div>
  </div>
  `;

  textboxHtml = `
  <div class=" col-md-4">
    <div class="form-row">
        <label>Text Box</label>
        <custom-text-box [type]="'text'" id="textbox" name="textbox"></custom-text-box>
    </div>
  </div>
  `;
  textboxLangHtml = `
  <div class=" col-md-4">
    <div class="form-row">
        <label>Text Box</label>
        <custom-text-box class="lang-text" [type]="'text'" id="textbox" name="textbox"></custom-text-box>
    </div>
  </div>
  `;
  
  requiredTextboxHtml = `
  <div class=" col-md-4">
    <div class="form-row" [ngClass]="{'required': true}">
        <label>Required Input<span class="required">*</span></label>
        <custom-text-box [ngClass]="{'required': true}" [type]="'text'" id="requiredTextbox" name="requiredTextbox"></custom-text-box>
        <div class="form-validation">Please Enter a valid value</div>
    </div>
  </div>
  `;

  selectDropdownHtml = `
  <form class="general-form">
      <div class="form-wrapper form-padding">
        <div class="row">
          <div class=" col-md-4" >
            <div class="form-row">
              <label>Single Select DropDown</label>
              <mutliselect id="selectDropdown" name="selectDropdown"
                           [propertyToSelect]="'key'"
                           [options]="dropdownOptions"
                           [viewMode]="true"
                           [multiple]="false"
                           [config]="config"
                           [(data)]="dataModel">
              </mutliselect>
            </div>
          </div>
        </div>
      </div>
    </form>
  `;

  multiSelectHtml = `
  <form class="general-form">
      <div class="form-wrapper form-padding">
        <div class="row">
          <div class=" col-md-4" #multiSelectContainer>
            <div class="form-row">
              <label>New Multiple Select DropDown</label>
              <mutliselect id="mutliselect" name="mutliselect"
                           [propertyToSelect]="'key'"
                           [options]="dropdownOptions"
                           [viewMode]="false"
                           [multiple]="true"
                           [config]="config"
                           [(data)]="SelectedValues">
              </mutliselect>
            </div>
          </div>
        </div>
      </div>
    </form>
  `;

  passwordHtml = `
  <div class=" col-md-4">
    <div class="form-row">
        <label>Password Textbox</label>
        <password-textbox [strength]='true' placeholder="Password" id="passwordTextbox" name="passwordTextbox"></password-textbox>
    </div>
  </div>
  `;

  islamicDatepickerHtml = `
  <div class=" col-md-4">
    <div class="form-row">
        <label>Islamic Date Picker</label>
        <ngbd-datepicker-islamiccivil id="islamicDatepicker" name="islamicDatepicker"></ngbd-datepicker-islamiccivil>
    </div>
  </div>
  `;
  datepickerHtml = `
  <div class=" col-md-4">
      <div class="form-row">
          <label>Date Picker</label>
          <ngbd-datepicker-popup name="datepicker" id="datepicker"></ngbd-datepicker-popup>
      </div>
  </div>
`;
  textareaHtml = `
  <div class=" col-md-4">
    <div class="form-row">
        <label>Textarea</label>
        <textarea placeholder="Please enter a description" name="textarea" id="textarea"></textarea>
    </div>
  </div>
  `;

  checkboxHtml = `
  <div class=" col-md-4">
    <div class="form-row">
        <label>Checkbox</label>
        <label class="check-box-container">
            <p class="txt-wrapper">To verify <a class="item-link underline" href="#">Terms and conditions</a> kindly check this item</p>
            <input type="checkbox" [checked]=true (change)="checked = !checked">
            <span class="checkmark"></span>
        </label>
    </div>
  </div>
  `;

  counterHtml = `
  <div class="col-2 col-md-4">
    <div class="form-row">
      <label>Vertical Counter</label>
      <counter id="verticalCounter" name="verticalCounter"></counter>
    </div>
  </div>
  `;

  horizontalCounterHtml = `
  <div class="col-2 col-md-4">
    <div class="form-row">
      <label>Horizontal Counter</label>
      <counter class="horizontal" id="horizontalCounter" name="horizontalCounter"></counter>
    </div>
  </div>
  `;

  radioHtml = `
  <div class=" col-md-4">
    <div class="custom-radio">
      <input type="radio" id="radio1" name="radio-group" [checked]="true">
      <label for="radio1">Radio Input</label>
    </div>
  </div>
  `;

  disabledRadioHtml = `
  <div class="col-2 col-md-4">
    <div class="form-row">
      <div class="custom-radio readonly">
        <input type="radio" id="radio2" name="radio-group">
        <label for="radio2">Readonly Radio Input</label>
      </div>
    </div>
  </div>
  `;

  toggleHtml = `
  <div class="col-2 col-md-4">
    <div class="form-row">
        <label>Toggle Button</label>
        <btn-toggle (changed)="checked=$event" [id]="toggleid || false" text="Toggle Button Label" name="btnToggle"></btn-toggle>
    </div>
  </div>
  `;

  modalHtml = `
  <div class=" col-md-4" #modalContainer>
      <div class="form-row">
          <label>Modal Form</label>
          <button class="main-btn" (click)="openFormModal()" id="modal" name="modal">Open Modal</button>
      </div>
  </div>
  `;

  uploadHtml = `
  <div class=" col-md-4">
    <div class="form-row">
        <label>Upload Input</label>
        <file-upload (fileChanged)='onFileChanged($event)' [allowedTypes]="'.png,.jpeg,.jpg'"></file-upload>
    </div>
  </div>
  `;

  richHtml = `
  <div class="col-12">
    <div class="form-row">
        <label>Rich HTML Component</label>
        <rich-html></rich-html>
    </div>
  </div>
  `;

  mainbtnHtml = `
  <div class="col-12">
    <div class="form-row">
        <button type="button" class="main-btn" id="mainBtn" name="mainBtn">Main Button</button>
    </div>
  </div>
  `;

  secMainbtnHtml = `
  <div class="col-12">
    <div class="form-row">
        <button type="button" class="main-btn-secondary" id="secondaryMainBtn" name="secondaryMainBtn">Secondary Button</button>
    </div>
  </div>
  `;
  secbtnHtml = `
  <div class="col-12 col-md-6 align-self-md-end">
    <button type="button" class="secondary-btn" id="secondaryBtn" name="secondaryBtn">Retrieve Manager Data</button>
  </div>
  `;


  disabledBtnsHtml = `
  <div class="col-12">
    <div class="form-row">
        <button type="button" class="main-btn" disabled id="disabledMainBtn" name="disabledMainBtn">
            Disabled Main Button
        </button>
        <button type="button" class="main-btn-secondary" disabled id="disabledSecondaryBtn" name="disabledSecondaryBtn">
            Disabled Secondary Button
        </button>
    </div>
  </div>
  `;

  spaceBtwBtnsHtml = `
  <div class="row justify-content-between no-gutters">
    <div class="form-row">
        <label>Buttons With Space Between</label>
    </div>
    <button type="button" class="main-btn" id="spaceMainBtn" name="spaceMainBtn">Main button</button>
    <button type="button" class="main-btn-secondary" id="spaceSecondaryBtn" name="spaceSecondaryBtn">Secondary button</button>
  </div>
  `;

  centerBtnsHtml = `
  <div class="row justify-content-center no-gutters">
    <div class="form-row">
        <label>Buttons Centered</label>
    </div>
    <button type="button" class="main-btn" id="centeredMainBtn" name="centeredMainBtn">Main button</button>
    <button type="button" class="main-btn-secondary" id="centeredSecondaryBtn" name="centeredSecondaryBtn">Secondary button</button>
  </div>
  `;


  tabsScrollHtml = `
  <form class="general-form" >
  <div class="form-wrapper form-padding">
      <div class="generic-tabs">
      <mat-tab-group>
      <mat-tab label="All Services" id="allServices" name="allServices">
        <p>Tab Content1 Tab Content1 Tab Content1 Tab Content1 Tab Content1.</p>
      </mat-tab>
      <mat-tab label="Land Transportation Licensing" id="landTransportationLicensing" name="landTransportationLicensing">
        <p>Tab Content1 Tab Content1 Tab Content1 Tab Content1 Tab Content1.</p>
      </mat-tab>
      <mat-tab label="Operating Cards" id="operatingCards" name="operatingCards">
        <p>Tab Content1 Tab Content1 Tab Content1 Tab Content1 Tab Content1.</p>
      </mat-tab>
      <mat-tab label="Yard" id="yard" name="yard">
        <p>Tab Content1 Tab Content1 Tab Content1 Tab Content1 Tab Content1.</p>
      </mat-tab>
    </mat-tab-group>
      </div>
  </div>
</form>
  `;
  tabsActionslHtml = `
    <div #tabsActionsContainer class="col-12 form-footer position-relative p-0 d-flex flex-column justify-content-center flex-md-row justify-content-md-between">
              <div>
                 <button type="button" class="main-btn" id="submit" name="submit">Submit</button>
                 <button type="button" class="main-btn-secondary" id="saveDraft" name="saveDraft">Save as Draft</button>
                 <button type="button" class="main-btn-secondary" id="cancel" name="cancel">Cancel</button>
              </div>
              <div class="tab-nav-wrapper">
                 <a aria-label="Next" title="Next" class="prev" (click)="NavigatePrevious()" id="nextNav" name="nextNav"></a>
                 <a aria-label="Prev" title="Previous" class="next" (click)="NavigateNext()" id="prevNav" name="prevNav"></a>
              </div>
            </div>
`;
  filterHtml = `
  <form class="general-form">
  <div class="form-wrapper form-padding">
      <div class="filter-wrapper grey-bg">
          <form class="form-horizontal form-wrapper form-padding" role="form">
              <label>Filter By</label>
              <div class="row filter-container">
                  <div class=" col-md-3">
                      <div class="form-row">
                          <label>Name</label>
                          <custom-text-box [type]="'text'" id="name" name="name"></custom-text-box>
                      </div>
                  </div>
                  <div class=" col-md-3">
                      <div class="form-row">
                          <label>Venue Type</label>
                          <mutliselect id="selectDropdown" name="selectDropdown" [propertyToSelect]="'key'"
                              [options]="dropdownOptions" [viewMode]="false" [multiple]="false"
                              [config]="config">
                          </mutliselect>
                      </div>
                  </div>
                  <div class="col-12">
                      <div class="form-row align-items-center h-100">
                          <button type="button" (click)="filterPermits()" class="main-btn" id="filter" name="filter">Filter</button>
                          <a href="#" (click)="resetPermitfiltration()" title=""
                              class="d-inline-block w-100 reset" id="resetFilter" name="resetFilter">Reset
                              Filter</a>
                      </div>
                  </div>
              </div>
          </form>
      </div>
  </div>
</form>
  `
  galleryHtml = `
            <div class="form-wrapper form-padding">
                <div class="row justify-content-center">
                    <div class=" col-md-8">
                        <ngb-carousel>
                            <ng-template ngbSlide>
                                <div class="picsum-img-wrapper">
                                    <img src="./assets/images/home-bg.png" alt="Random first slide" id="homeBg">
                                </div>
                            </ng-template>
                            <ng-template ngbSlide>
                                <div class="picsum-img-wrapper">
                                    <img  alt="Default Image" class="defaultImg" src="./assets/images/default-gallery.png" alt="Random second slide" id="defaultImg">
                                </div>
                            </ng-template>
                            <ng-template ngbSlide>
                                <div class="picsum-img-wrapper">
                                    <img src="./assets/images/home-bg.png" alt="Random third slide" id="homeBg">
                                </div>
                            </ng-template>
                        </ngb-carousel>
                    </div>
                </div>
            </div>
  `
  detailsGridHtml = `
  <form class="general-form">
    <div class="form-wrapper form-padding">
        <section class="order-grid">
            <h4 class="card-title">Details Table</h4>
            <table class="table-strip space-between">
                <tr>
                    <td>Order1</td>
                    <td>2650 SAR</td>
                </tr>
                <tr>
                    <td>Order2</td>
                    <td>2650 SAR</td>
                </tr>
                <tr>
                    <td>Order3</td>
                    <td>2650 SAR</td>
                </tr>
            </table>
        </section>
    </div>
  </form>
  `;

  gridHtml = `
  <form class="general-form">
    <div class="form-wrapper form-padding">
        <div class="table-title position-relative">
            <h6 class="d-inline-block">Table Title</h6>
            <a href="#" class="add-record" title="Add New Record"><i class="icon-add1"></i>Add New Record</a>
            <table class="table-template">
                <thead>
                    <tr>
                        <th>Optimize</th>
                        <th>Optimize</th>
                        <th>Optimize</th>
                        <th>Optimize</th>
                        <th>Options</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="accordion">
                            <span>Steering Committee</span>
                            <span class="icon hide-block-768"></span>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Process Group : </span>
                            <span> accountant</span>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Process Group : </span>
                            <span> accountant</span>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Download : </span>
                            <a href="#" alt="hh" title="hamada" class="svg-holder" id="file">
                                <span> PM L&D Plan Template.docx</span>
                            </a>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Process Group : </span>
                            <div class="options">
                                <a href="#" class="icon-edit" id="iconEdit" title="Edit"></a>
                                <a href="#" class="icon-rubbish-bin" id="iconDelete" title="Delete"></a>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="accordion">
                            <span>Steering Committee</span>
                            <span class="icon hide-block-768"></span>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Process Group : </span>
                            <span> accountant</span>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Process Group : </span>
                            <span> accountant</span>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Download : </span>
                            <a href="#" alt="hh" title="hamada" class="svg-holder" id="file">
                                <span> PM L&D Plan Template.docx</span>
                            </a>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Process Group : </span>
                            <div class="options">
                                <a href="#" class="icon-edit" id="iconEdit" title="Edit"></a>
                                <a href="#" class="icon-rubbish-bin" id="iconDelete" title="Delete"></a>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="accordion">
                            <span>Steering Committee</span>
                            <span class="icon hide-block-768"></span>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Process Group : </span>
                            <span> accountant</span>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Process Group : </span>
                            <span> accountant</span>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Download : </span>
                            <a href="#" alt="hh" title="hamada" class="svg-holder" id="file">
                                <span> PM L&D Plan Template.docx</span>
                            </a>
                        </td>
                        <td class="panel">
                            <span class="hide-block-768">Process Group : </span>
                            <div class="options">
                                <a href="#" class="icon-edit" id="iconEdit" title="Edit"></a>
                                <a href="#" class="icon-rubbish-bin" id="iconDelete" title="Delete"></a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </form>
  `;

  paginationHtml = `
  <ngb-pagination [rotate]="true" [collectionSize]="70" [(page)]="page" [maxSize]="5" aria-label="Default pagination" [pageSize]="5"></ngb-pagination>
  `;
  alertsHtml = `
            <div class="col-12">
                <div class="alert alert-primary" role="alert">
                    This is a primary alert—check it out!
                </div>
            </div>
            <div class="col-12">
                <div class="alert alert-secondary" role="alert">
                    This is a secondary alert—check it out!
                </div>
            </div>
            <div class="col-12">
                <div class="alert alert-success" role="alert">
                    This is a success alert—check it out!
                </div>
            </div>
            <div class="col-12">
                <div class="alert alert-danger" role="alert">
                    This is a danger alert—check it out!
                </div>
            </div>
            <div class="col-12">
                <div class="alert alert-warning" role="alert">
                    This is a warning alert—check it out!
                </div>
            </div>
            <div class="col-12">
                <div class="alert alert-info" role="alert">
                    This is a info alert—check it out!
                </div>
            </div>
            <div class="col-12">
                <div class="alert alert-light" role="alert">
                    This is a light alert—check it out!
                </div>
            </div>
            <div class="col-12">
                <div class="alert alert-dark" role="alert">
                    This is a dark alert—check it out!
                </div>
            </div>
  `
  // sucMsgHtml = `
  // <message [mode]="success"></message>
  // `;

  // errMsgHtml = `
  // <message [mode]="error"></message>
  // `;

  // warMsgHtml = `
  // <message [mode]="warning"></message>
  // `;
  empMsgHtml =`
  <div class="empty-template">
        There is no data to show
    </div>
  `
  // checkbox
  public checked: boolean = true;

  // drop down viewed options
  selectedOptions = ['Ahmed', 'Abdelaziz'];

  // Dropdown options 
  singleSelect = ['Egyptian'];
  dropdownOptions = [];
  dataModel: number = 2;
  // Dropdown Configurations
  config = {
    displayKey: "name", //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    placeholder: 'Select', // text to be displayed when no item is selected defaults to Select,
    noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
    searchPlaceholder: 'Search', // label thats displayed in search input,
    //searchOnKey: 'name' // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  }

  //popup inputs
  modalTitle = "modal title";
  modalBody = "modal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgdmodal body cfgfdgd ";
  objectsArray: any = [];
  //Modal//
  constructor(
    private modalService: NgbModal

  ) { } //private _clipboardService: ClipboardService
  openFormModal() {
    const modalRef = this.modalService.open(ModalFormComponent);
    modalRef.componentInstance.id = 10; // should be the id

    modalRef.result.then((result) => {
      console.log(result);
    }).catch((error) => {
      console.log(error);
    });
  }

  SelectedValues: any[] = [];
  ngOnInit() {
    this.SelectedValues.push(1);
    this.SelectedValues.push(0);

    this.dropdownOptions = [{ key: 0, name: 'Ahmed' }, { key: 1, name: 'Carol' }, { key: 2, name: 'Rehan' }];
  }

  ngAfterViewInit() { }

  onClickedOutside(e: Event) {

    setTimeout(() => {
      console.log('Clicked outside:', e);

    }, 100);
  }

  // copy(text: string){
  //   this._clipboardService.copyFromContent(text);
  // }

  emailOnBlur(Event) { }

  onFileChanged(Event) { }

}
